import { Typography } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation, useParams } from 'react-router';

import { viewTitleID } from '../../../utils/accessibility';
import { COOKIE_MODAL_ROOT_ID } from '../../../utils/constants';

const ViewTitle = ({ initialLoad, messageId, actionSetInitialLoad }) => {
  const titleRef = useRef(null);
  const location = useLocation();
  const params = useParams();

  useEffect(() => {
    if (location.hash && location.hash !== '') {
      const elem = document.querySelector(location.hash);
      if (elem) {
        elem.focus();
        return;
      }
    }
    if (initialLoad) {
      if (titleRef.current) {
        titleRef.current.focus();
      }
    } else {
      actionSetInitialLoad();

      setTimeout(() => {
        // If cookie modal is visible prevent focusing
        let shouldFocus = true;
        try {
          shouldFocus = !document.getElementById(COOKIE_MODAL_ROOT_ID);
        } catch {
          console.warn(
            'Error while attempting to figure out if cookie modal exists'
          );
        }

        // Focus to site title on first load if cookihub banner is hidden
        const appTitle = document.getElementById('app-title');
        if (appTitle && shouldFocus) {
          appTitle.focus();
        }
      }, 800);
    }
  }, [initialLoad, actionSetInitialLoad, location.hash]);

  const type = params.type || '';
  let message = messageId;

  if (location.search.includes('feedback=true')) {
    message = 'general.pageTitles.feedback';
  }

  return (
    <Typography
      id={viewTitleID}
      style={visuallyHidden}
      component="h2"
      tabIndex={-1}
      ref={titleRef}
    >
      <FormattedMessage id={message + type} />
    </Typography>
  );
};

ViewTitle.propTypes = {
  initialLoad: PropTypes.bool.isRequired,
  messageId: PropTypes.string.isRequired,
  actionSetInitialLoad: PropTypes.func.isRequired,
};

export default ViewTitle;
